import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';

@Injectable()
export class KendoMessageService extends MessageService {
  private ngxTranslateService = inject(TranslateService);

  // get translation of a Kendo-Component
  public override get(key: string): string {
    return this.ngxTranslateService.instant(key);
  }
}
